<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage
	} from '@/api/approval'
	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo
	} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
		title: null,
		url: null,
		toUser: [],
		desc: null,
		template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				sendMessageData: Object.assign({}, sendMessagetTemplate),
				formLoading: false,
				listLoading: false,
				flowId: null,
				isDisabled: false
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			clickChoose: async function(dataVal, name) {
				
			},
			getTemplate: async function() {
				this.listLoading = true;
				const that = this;
				await this.getEmployeeRelation();
				var title = that.logInfo.fullName;
				var EmpName = that.logInfo.EmpName;
				var DeptName= that.logInfo.DeptName;
				var EmpNo = that.logInfo.EmpNo;
				var EmpNoList = ["SC12050030","SC19002230","SC18000093","SC18009803"] //邓虹 姚双玉 姜莉 文燕
				if(EmpNoList.indexOf(EmpNo)===-1){
				  that.Message({
				    message: '没有申请权限',
				    type: 'error',
				    duration: 2000
				  });
				  this.isDisabled=true;
				}
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item, index) => {
						//var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "申请部门") {
							item.Value=DeptName;
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请人") {
							item.Value=EmpName;
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请日期"){
							item.Value = new Date().toLocaleDateString();
							item.Disable = true;
						}
						//
						if (item.Property.Title[0].Text == "申请事宜"){
							item.Value = '二级市场其他类申请';
							item.Disable = true;
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					//this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
					this.listLoading = false;
				});

			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				this.isDisabled = true
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					this.isDisabled = false
					return;
				}
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "文档内容"})[0]
				var text = '';
				if(control.Value){
					text=control.Value.substring(0,50);
				}
				info.SummaryInfo.push({"Text":"文档内容："+text,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				
				isSubmit = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData, this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).catch(e => {
					this.isDisabled = true
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
